import React, { Fragment, useEffect } from 'react';
import { Skeleton, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import { useLazyReadOrderQuery } from '../service/orders';
import { getModalContent, renderOrderInfo } from '../utils/getModalContent';
import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { OrdersProducts } from '../components/OrdersProducts';

const { Title } = Typography;

export const OrderModal = () => {
    const { orderId } = useParams();
    const navigate = useNavigate();

    const [getOrder, { data, isLoading }] = useLazyReadOrderQuery();

    useEffect(() => {
        if (orderId) {
            getOrder(+orderId, true);
        }
    }, [orderId]);

    const closeModal = () => {
        navigate(-1);
    };

    return (
        <GenericModal
            title={`Заказ №${orderId}`}
            width={720}
            open={true}
            onCancel={closeModal}
            destroyOnClose
            footer={null}
        >
            {isLoading ? (
                <Skeleton />
            ) : (
                <div style={{ marginTop: '32px' }}>
                    {getModalContent(data).map((item, index) => (
                        <Fragment key={index}>
                            {renderOrderInfo(item.name, item.value, item.type)}
                        </Fragment>
                    ))}
                </div>
            )}

            <Title style={{ marginBottom: 0 }} level={5}>
                Список товаров
            </Title>
            <OrdersProducts items={data?.product_list || []} />
        </GenericModal>
    );
};
